const API_URL = "https://sme-account-center-api.vercel.app/api";

const ADMIN_URL = API_URL + "/admin/v1";
const USER_URL = API_URL + "/v1";

export {API_URL , ADMIN_URL , USER_URL}